import React, { Component } from "react";
import PropTypes from "prop-types";

import CommentsService from "services/CommentsService";

import CommentsOverview from "./CommentsOverview";
import CommentsForm from "./CommentsForm";

class CommentsContainer extends Component {
  constructor(props) {
    super(props);

    this.ketCommentsRef = React.createRef();

    const { open } = this.props;

    this.state = {
      comments: [],
      commentsOpen: open || false,
      loading: true,
    };
  }

  componentDidMount = () => {
    this.getComments();
  };

  getComments = async () => {
    const { uuid } = this.props;
    const comments = await CommentsService.getComments(uuid);

    this.setState({
      comments,
      loading: false,
    });
  };

  handleCommentsToggle = () => {
    this.setState((prevState) => {
      return {
        commentsOpen: !prevState.commentsOpen,
      };
    });
  };

  buttonText = () => {
    const { loading, comments } = this.state;

    if (loading) return "...";
    if (comments.length === 0) {
      return "Reageer als eerste.";
    }
    return `Al ${comments.length} ${
      comments.length === 1 ? "reactie" : "reacties"
    }. Laat ook van je horen.`;
  };

  onScrollTop = () => {
    this.ketCommentsRef.current.scrollIntoView({
      behaviour: "smooth",
    });
  };

  render() {
    const { comments, loading, commentsOpen } = this.state;

    const { uuid, rules, hideButton } = this.props;

    return (
      <div className="ket-comments container--text" ref={this.ketCommentsRef}>
        {!hideButton ? (
          <button
            className="ket-comments__open"
            onClick={this.handleCommentsToggle}
            type="button"
            disabled={loading}
          >
            <span className="btn__text" aria-hidden="true">
              {this.buttonText()}
            </span>
            <svg className="btn__icon is-suffix" width="14" height="9">
              <use xlinkHref="#chevron-down" width="14" height="9" />
            </svg>
          </button>
        ) : (
          <h3 className="ket-comments__title">Reacties:</h3>
        )}
        <CommentsOverview
          comments={comments}
          open={commentsOpen}
          key="CommentsOverview"
        />
        <CommentsForm
          uuid={uuid}
          rules={rules}
          open={commentsOpen}
          onScrollTop={this.onScrollTop}
          key="CommentsForm"
        />
      </div>
    );
  }
}

CommentsContainer.propTypes = {
  uuid: PropTypes.string.isRequired,
  rules: PropTypes.string,
  open: PropTypes.bool,
};

CommentsContainer.defaultProps = {
  rules: null,
  open: false,
};

export default CommentsContainer;
